import { OrderListWarning } from "../models/orderListModels";

export const deduplicateOrderListWarnings = (
  warnings: OrderListWarning[]
): OrderListWarning[] => {
  const uniqueWarnings = new Map<string, OrderListWarning>();
  warnings.forEach(warning => {
    const key = [warning.code, warning.message, warning.product ?? "", warning.category ?? ""].join("|");
    if (!uniqueWarnings.has(key)) {
      uniqueWarnings.set(key, warning);
    }
  });
  return Array.from(uniqueWarnings.values());
};